<table>
  <thead>
    <th>Accession Number</th>
    <th>Modality</th>
    <th>Study Description</th>
    <th class="status-header">Order Status</th>
  </thead>
  <tbody>
    <tr class="order-row" *ngFor="let order of orders">
      <td>
        {{ order.accessionNumber }}
      </td>
      <td>
        {{ order.modality }}
      </td>
      <td>
        {{ order.studyDescription }}
      </td>
      <td>
        <div>
          <div *ngIf="!order.reportText">
            <p class="{{ order.statusDescriptionClass ?? '' }} badge">
              {{ order.statusDescription ?? 'Loading...' }}
            </p>
          </div>
          <button
            id="view-report"
            class="view-report"
            (click)="viewReport(order.accessionNumber)"
            *ngIf="order.reportText"
          >
            View Report
          </button>
        </div>
      </td>
    </tr>
  </tbody>
</table>
